import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import DesignationDetailsTab from '../../../features/designations/DesignationDetailsTab';
import { useNewDesignationMutation, useModifyDesignationMutation } from '../../../api/designations';

const AddEditDesignation = (props) => {
    const params = useParams();
    const [designationDetails, setDesignationDetails] = useState({});
    const location = useLocation();
    const isEditMode = location.pathname.includes('edit');
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();
    const [newDesignation, { isLoading: isNewLoading }] = useNewDesignationMutation();
    const [modifyDesignation, { isLoading: isModifyLoading }] = useModifyDesignationMutation();

    const isLoading = isNewLoading || isModifyLoading;

    useEffect(() => {
        const fetchData = async () => {
            const bodyFormData = new FormData();
            try {
                let response;
                if (isEditMode) {
                    bodyFormData.append('id', params.id);
                    response = await modifyDesignation(bodyFormData).unwrap();
                } else {
                    response = await newDesignation(bodyFormData).unwrap();
                }
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setDesignationDetails(response);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        };

        fetchData();
    }, [params.id, isEditMode, newDesignation, modifyDesignation, enqueueSnackbar]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">{isEditMode ? 'Edit Designation' : 'Add Designation'}</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/designations')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            sx={{
                                pt: 1,
                            }}
                        >
                            <DesignationDetailsTab
                                isEditMode={isEditMode}
                                designationDetails={designationDetails}
                                isLoading={isLoading}
                            />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AddEditDesignation;
